import { useDisclosure } from 'src/utils'
import DatePickerInput from './DatePickerInput'
import { useController } from 'react-hook-form'
import { forwardRef, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'

import './DatePicker.css'

interface Props {
  value?: Date | null | [Date | null, Date | null]
  onChange?: (dates: [Date | null, Date | null]) => void
  name: string
  label?: string
  className?: string
}

const DatePickerForm = (
  { value, onChange, name, label, className, ...rest }: Props,
  ref: any
) => {
  const { field, fieldState } = useController({ name })
  const [selected, setSelected] = useState<Date | null>()
  const { isOpen, toggle, close } = useDisclosure()
  const pickerRef = useRef<HTMLDivElement>(null) // Reference for outside click detection

  const handleOnSelect = (d: Date | null) => {
    console.log(d, 'lllllll')
    setSelected(d)
    field.onChange(d)
    close() // Optionally close the dropdown after selection
  }

  return (
    <div
      ref={pickerRef}
      className={`min-w-[350px] u-pay-date-picker-container ${className}`}
    >
      <DatePicker
        ref={ref}
        selected={selected}
        onChange={handleOnSelect}
        open={isOpen}
        showPopperArrow={false}
        popperPlacement='bottom'
        popperContainer={({ children }) => <div>{children}</div>} // Ensures it renders in a div outside constraints
        className='width-full'
        portalId='datepicker-portal' // Portal ID (Optional)
        {...rest}
        customInput={
          <DatePickerInput
            {...{
              value: selected?.toLocaleDateString?.(),
              label: label || 'Date Range',
              toggleDropdown: toggle,
              error: fieldState.error?.message,
            }}
          />
        }
      />
    </div>
  )
}

export default forwardRef(DatePickerForm)
